<template>
    <SubHeader title="Conversation IA" :breads="[{ name: 'IAConversation' }]" :action="{}" />

    <div class="chat-container">
        <div class="chat-wrapper">
            <!-- Historique des conversations -->
            <div class="chat-sidebar" v-if="conversations.length > 0">
                <div class="sidebar-header">
                    <h3>Historique</h3>
                    <button class="btn-new-chat" @click="startNewChat">
                        <i class="fas fa-plus"></i> Nouveau
                    </button>
                </div>
                <div class="conversation-list">
                    <div v-for="conv in conversations" :key="conv.id" class="conversation-item"
                        :class="{ active: currentChat?.id === conv.id }" @click="loadChat(conv.id)">
                        <div class="conv-preview">
                            <span class="conv-title">{{ conv.title || 'Nouvelle conversation' }}</span>
                            <span class="conv-date">{{ formatDate(conv.updatedAt) }}</span>
                        </div>
                        <button class="btn-delete" @click.stop="deleteConversation(conv.id)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Zone de chat principale -->
            <div class="chat-main">
                <div class="chat-header">
                    <div class="chat-title">
                        <img :src="logo" alt="AI Logo" class="ai-logo" />
                        <h2>{{ currentChat?.title || 'Nouvelle conversation' }}</h2>
                    </div>
                    <div class="chat-actions">
                        <button class="btn-action" @click="toggleSidebar" v-if="conversations.length > 0">
                            <i class="fas fa-history"></i>
                        </button>
                        <button class="btn-action" @click="startNewChat">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>

                <div class="chat-messages" ref="messagesContainer" style="position: relative;">
                    
                    <div v-for="(message, index) in messages" :key="index" :class="['message', message.role]">
                        <div class="message-avatar">
                            <i v-if="message.role === 'assistant'" class="bi bi-robot"></i>
                            <i v-else class="bi bi-person-fill"></i>
                        </div>
                    
                        <div class="message-content">
                            <div class="message-text" v-html="formatMessage(message.content)"></div>
                            <div class="message-time">{{ formatTime(message.timestamp) }}</div>
                        </div>
                    </div>
                    <div v-if="isLoading"   class="message assistant">
                        <div class="message-avatar">
                            <i  class="bi bi-robot"></i>
                        </div>
                        <div class="message-content">
                            <div class="message-text typing-indicator">
                                <span></span><span></span><span></span>
                            </div>
                        </div>
                       
                    </div>

                    
                </div>

                <div class="chat-input-area">
                    <form @submit.prevent="sendMessage">
                        <div class="input-wrapper">
                            <input v-model="userInput" type="text"
                                placeholder="Posez votre question au coordinateur IA..." :disabled="isLoading"
                                @keyup.enter="sendMessage" />
                            <button type="submit" :disabled="!userInput || isLoading">
                                <i class="bi bi-send"></i>
                            </button>
                        </div>
                        <div class="input-actions">
                            <button type="button" class="btn-suggest" @click="showSuggestions = !showSuggestions">
                                <i class="bi bi-lightbulb"></i> Suggestions
                            </button>
                            <div v-if="showSuggestions" class="suggestions-box">
                                <div class="suggestion"
                                    @click="selectSuggestion('Combien de plaintes ont été déposées ce mois-ci ?')">
                                    Combien de plaintes ont été déposées ce mois-ci ?
                                </div>
                                <div class="suggestion"
                                    @click="selectSuggestion('Quel est le taux de résolution des plaintes ?')">
                                    Quel est le taux de résolution des plaintes ?
                                </div>
                                <div class="suggestion"
                                    @click="selectSuggestion('Quels types de plaintes sont les plus fréquents ?')">
                                    Quels types de plaintes sont les plus fréquents ?
                                </div>
                                <div class="suggestion"
                                    @click="selectSuggestion('Quels services reçoivent le plus de plaintes ?')">
                                    Quels services reçoivent le plus de plaintes ?
                                </div>
                                <div class="suggestion"
                                    @click="selectSuggestion('Quel est le délai moyen de traitement d\'une plainte ?')">
                                    Quel est le délai moyen de traitement d'une plainte ?
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubHeader from "@/layouts/admin/SubHeader.vue"
import logo from "@/assets/logos/logo_.png"
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

export default {
    name: "IAChatbot",
    components: {
        SubHeader,
    },
    data() {
        return {
            searchWord: null,
            fileServeur: process.env.VUE_APP_FILE_SERVER_ULR ?? "",
            logo,

            // Données du chat
            conversations: [],
            currentChat: null,
            messages: [],
            userInput: '',
            isLoading: false,
            showSidebar: true,
            showSuggestions: false,

            exampleConversations: [
                // {
                //     id: 1,
                //     title: "Questions sur les projets",
                //     updatedAt: new Date(),
                //     messages: [
                //         { role: 'user', content: "Comment créer un nouveau projet ?", timestamp: new Date(Date.now() - 3600000) },
                //         { role: 'assistant', content: "Pour créer un nouveau projet, allez dans la section 'Projets' puis cliquez sur 'Nouveau projet'. Remplissez le formulaire avec les informations requises.", timestamp: new Date(Date.now() - 3500000) }
                //     ]
                // },
                // {
                //     id: 2,
                //     title: "Délais à respecter",
                //     updatedAt: new Date(Date.now() - 86400000),
                //     messages: [
                //         { role: 'user', content: "Quels sont les délais pour le projet X ?", timestamp: new Date(Date.now() - 86400000) },
                //         { role: 'assistant', content: "Le projet X doit être terminé pour le 15 novembre. Les revues intermédiaires sont prévues les 1er et 10 novembre.", timestamp: new Date(Date.now() - 86300000) }
                //     ]
                // }
            ]
        }
    },
    computed: {
    },
    created() {
        this.conversations = this.exampleConversations
        if (this.conversations.length > 0) {
            this.currentChat = this.conversations[0]
            this.messages = this.currentChat.messages
        } else {
            this.startNewChat()
        }
    },
    methods: {

        async callBackend(userMessage) {
            const response = await fetch(process.env.VUE_APP_AUDIO_AND_IA_URL+'/ia-chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ message: userMessage })
            })

            if (!response.ok) throw new Error('Réponse non valide')

            const data = await response.json()
            return data.reply || "Pas de réponse trouvée."
        },

        startNewChat() {
            const newChat = {
                id: Date.now(),
                title: 'Nouvelle conversation',
                updatedAt: new Date(),
                messages: []
            }
            this.conversations.unshift(newChat)
            this.currentChat = newChat
            this.messages = []
            this.userInput = ''
        },

        loadChat(chatId) {
            this.currentChat = this.conversations.find(c => c.id === chatId)
            this.messages = this.currentChat?.messages || []
            this.showSidebar = false
        },

        deleteConversation(chatId) {
            this.conversations = this.conversations.filter(c => c.id !== chatId)
            if (this.currentChat?.id === chatId) {
                if (this.conversations.length > 0) {
                    this.loadChat(this.conversations[0].id)
                } else {
                    this.startNewChat()
                }
            }
        },

        // async sendMessage() {
        //     if (!this.userInput.trim() || this.isLoading) return

        //     const userMessage = {
        //         role: 'user',
        //         content: this.userInput,
        //         timestamp: new Date()
        //     }

        //     // Ajouter le message de l'utilisateur
        //     this.messages.push(userMessage)
        //     this.currentChat.messages = this.messages

        //     // Générer un titre si c'est le premier message
        //     if (this.messages.length === 1) {
        //         this.currentChat.title = this.generateTitle(this.userInput)
        //     }

        //     this.currentChat.updatedAt = new Date()
        //     this.userInput = ''

        //     // Simuler une réponse de l'IA
        //     this.isLoading = true
        //     await this.simulateAIResponse()
        //     this.isLoading = false

        //     // Faire défiler vers le bas
        //     this.$nextTick(() => {
        //         this.scrollToBottom()
        //     })
        // },

        async sendMessage() {
            if (!this.userInput.trim() || this.isLoading) return

            const userMessage = {
                role: 'user',
                content: this.userInput,
                timestamp: new Date()
            }

            this.messages.push(userMessage)
            this.currentChat.messages = this.messages

            if (this.messages.length === 1) {
                this.currentChat.title = this.generateTitle(this.userInput)
            }

            this.currentChat.updatedAt = new Date()
            const userText = this.userInput
            this.userInput = ''
            this.isLoading = true

            try {
                const response = await this.callBackend(userText)
                this.messages.push({
                    role: 'assistant',
                    content: response,
                    timestamp: new Date()
                })
                this.currentChat.updatedAt = new Date()
            } catch (error) {
                console.error("Erreur backend :", error)
                this.messages.push({
                    role: 'assistant',
                    content: "Une erreur est survenue en contactant l'IA.",
                    timestamp: new Date()
                })
            }

            this.isLoading = false
            this.$nextTick(() => {
                this.scrollToBottom()
            })
        },


        simulateAIResponse() {
            return new Promise(resolve => {
                setTimeout(() => {
                    const responses = {
                        "Comment créer un nouveau projet ?": "Pour créer un nouveau projet, allez dans la section 'Projets' puis cliquez sur 'Nouveau projet'. Remplissez le formulaire avec les informations requises et validez.",
                        "Quels sont les délais à respecter ?": "Les délais dépendent du type de projet. En général, les projets standard ont une durée de 2 semaines. Consultez le calendrier pour les dates exactes.",
                        "Comment assigner des tâches à mon équipe ?": "Dans l'onglet 'Équipe', sélectionnez les membres concernés et utilisez la fonction 'Assigner une tâche'. Vous pouvez également définir des échéances."
                    }

                    const lastUserMessage = this.messages[this.messages.length - 1].content
                    const aiResponse = responses[lastUserMessage] || "Je suis désolé, je n'ai pas compris votre question. Pouvez-vous la reformuler ? Je suis spécialisé dans l'aide aux coordinateurs pour la gestion de projets et d'équipes."

                    this.messages.push({
                        role: 'assistant',
                        content: aiResponse,
                        timestamp: new Date()
                    })

                    this.currentChat.messages = this.messages
                    this.currentChat.updatedAt = new Date()

                    resolve()
                }, 1500) // Délai simulé pour la réponse de l'IA
            })
        },

        generateTitle(message) {
            if (message.length > 30) {
                return message.substring(0, 30) + '...'
            }
            return message
        },

        selectSuggestion(suggestion) {
            this.userInput = suggestion
            this.showSuggestions = false
        },

        toggleSidebar() {
            this.showSidebar = !this.showSidebar
        },

        scrollToBottom() {
            const container = this.$refs.messagesContainer
            if (container) {
                container.scrollTop = container.scrollHeight
            }
        },

        formatDate(date) {
            return format(new Date(date), 'dd/MM/yyyy HH:mm', { locale: fr })
        },

        formatTime(date) {
            return format(new Date(date), 'HH:mm', { locale: fr })
        },

        formatMessage(content) {
            // Simple formattage pour les retours à la ligne
            return content.replace(/\n/g, '<br>')
        }
    },
    watch: {
        messages() {
            this.$nextTick(() => {
                this.scrollToBottom()
            })
        }
    }
}
</script>

<style scoped>
body {
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.chat-container {
    padding: 20px;
    height: calc(100vh - 120px);
    max-width: 1400px;
    margin: 0 auto;
    overflow: hidden;
}

.chat-wrapper {
    display: flex;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.conversation-list {
    flex: 1;
    overflow-y: auto;
    height: calc(100% - 60px);
}

.chat-sidebar {
    width: 300px;
    border-right: 1px solid #eee;
    background: #f9f9f9;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
}

.sidebar-header {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.sidebar-header h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.btn-new-chat {
    background: #4a6cf7;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-new-chat:hover {
    background: #3a5ce4;
}

.conversation-list {
    flex: 1;
    overflow-y: auto;
}

.conversation-item {
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s;
}

.conversation-item:hover {
    background: #f0f0f0;
}

.conversation-item.active {
    background: #e6edff;
    border-left: 3px solid #4a6cf7;
}

.conv-preview {
    flex: 1;
    overflow: hidden;
}

.conv-title {
    display: block;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.conv-date {
    font-size: 12px;
    color: #888;
}

.btn-delete {
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    padding: 4px;
    margin-left: 8px;
}

.btn-delete:hover {
    color: #ff4d4f;
}

.chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.chat-header {
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chat-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.chat-title h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
}

.ai-logo {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
}

.chat-actions {
    display: flex;
    gap: 8px;
}

.btn-action {
    background: none;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #666;
}

.btn-action:hover {
    background: #f5f5f5;
    color: #333;
}

.chat-messages {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background: #fafafa;
    height: calc(100% - 140px);
}

.message {
    display: flex;
    margin-bottom: 20px;
    max-width: 80%;
}

.message.user {
    margin-left: auto;
    flex-direction: row-reverse;
}

.message.assistant {
    margin-right: auto;
}

.message-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 12px;
    flex-shrink: 0;
}

.message.user .message-avatar {
    background: #4a6cf7;
    color: white;
}

.message-content {
    display: flex;
    flex-direction: column;
}

.message.user .message-content {
    align-items: flex-end;
}

.message-text {
    padding: 12px 16px;
    border-radius: 18px;
    line-height: 1.5;
    font-size: 15px;
}

.message.assistant .message-text {
    background: white;
    border: 1px solid #e6e6e6;
    border-top-left-radius: 4px;
}

.message.user .message-text {
    background: #4a6cf7;
    color: white;
    border-top-right-radius: 4px;
}

.message-time {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
}

.typing-indicator {
    display: flex;
    gap: 4px;
}

.typing-indicator span {
    width: 8px;
    height: 8px;
    background: #ccc;
    border-radius: 50%;
    display: inline-block;
    animation: typing 1.4s infinite both;
}

.typing-indicator span:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes typing {
    0% {
        transform: translateY(0);
        opacity: 0.4;
    }

    50% {
        transform: translateY(-4px);
        opacity: 1;
    }

    100% {
        transform: translateY(0);
        opacity: 0.4;
    }
}

.chat-input-area {
    padding: 16px;
    border-top: 1px solid #eee;
    background: white;
}

.input-wrapper {
    display: flex;
    border: 1px solid #ddd;
    border-radius: 24px;
    overflow: hidden;
    padding: 4px;
}

.input-wrapper input {
    flex: 1;
    border: none;
    padding: 12px 16px;
    font-size: 15px;
    outline: none;
}

.input-wrapper button {
    width: 48px;
    height: 48px;
    border: none;
    background: #4a6cf7;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-wrapper button:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.input-actions {
    margin-top: 12px;
    position: relative;
}

.btn-suggest {
    background: none;
    border: none;
    color: #4a6cf7;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
}

.suggestions-box {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 10;
    margin-bottom: 8px;
}

.suggestion {
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;
}

.suggestion:hover {
    background: #f9f9f9;
}

.suggestion:last-child {
    border-bottom: none;
}

/* Responsive */
@media (max-width: 768px) {

    .chat-container {
        height: calc(100vh - 80px);
        padding: 10px;
    }

    .chat-messages {
        height: calc(100% - 120px);
    }

    .chat-sidebar {
        position: absolute;
        z-index: 100;
        width: 280px;
        height: 100%;
        left: 0;
        transform: translateX(-100%);
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    }

    .chat-sidebar.show {
        transform: translateX(0);
    }

    .chat-main {
        width: 100%;
    }


    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .loading-spinner {
        color: white;
        font-size: 24px;
    }

    .spinner {
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top: 4px solid white;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
}
</style>